import {
  Box,
  Button,
  Grid,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Autocomplete,
  Checkbox,
  FormControlLabel,
  TextField,
  useTheme,Divider,
} from "@mui/material";
import { tokens } from "../../../theme/theme";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import Cancel from "@mui/icons-material/CancelOutlined";
import { useEffect, useState } from "react";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";
import Header from "../../../Layout/Header";
import GsmRangeActionMenu from "./GsmRangeActionMenu";

const AddGsmRange = ({ priceListId, priceListName, handlecallback }) => {
  const [quality, setQuality] = useState(null);
  const [qualityOptions, setQualityOptions] = useState([]);
  const [gsmRanges, setGsmRanges] = useState([]);
  const [retainGsm, setRetainGsm] = useState(false);
  const [breakdownData, setBreakdownData] = useState([]);

  const [qualityLocked, setQualityLocked] = useState(false);
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  useEffect(() => {
    const fetchQualities = async () => {
      try {
        const param = { p_companyid: 1, p_plantid: 1 };
        const qualityRes = await callApi(
          API_ENDPOINTS.SALES_PRICELIST_GET_ALL_QUALITIES,
          "POST",
          { "Content-Type": "application/json" },
          param
        );
        setQualityOptions(qualityRes || []);
      } catch (err) {
        console.error("Error loading quality options:", err);
      }
    };
    fetchQualities();
  }, []);

  useEffect(() => {
    if (priceListId) {
      handleShowBreakdown();
    }
  }, [priceListId]);

  const handleAddGsmRow = () => {
    const last = gsmRanges[gsmRanges.length - 1];
    let start = "";
    let end = "";

    if (retainGsm && last) {
      const prevStart = parseInt(last.gsmStart);
      const prevEnd = parseInt(last.gsmEnd);
      const diff = prevEnd - prevStart;
      start = prevEnd + 1;
      end = start + diff;
    }

    if (!retainGsm || !last) {
      start = "";
      end = "";
    }

    if (start !== "" && end !== "") {
      const isOverlapping = gsmRanges.some(
        (row) =>
          start <= row.gsmEnd &&
          end >= row.gsmStart &&
          !(end === row.gsmStart || start === row.gsmEnd)
      );
      if (isOverlapping) {
        alert("New GSM range overlaps with an existing range.");
        return;
      }
    }

    setGsmRanges((prev) => [
      ...prev,
      {
        id: Date.now(),
        gsmStart: start,
        gsmEnd: end,
        reelPrice: "",
        sheetPrice: ""
      }
    ]);

    setQualityLocked(false);
    setIsUpdateMode(false);
    setEditingId(null);
    setSelectedRow(null);
  };

  const handleShowBreakdown = async () => {
    if (!priceListId) {
      alert("Price List ID is missing.");
      return;
    }
    const param = {
      p_companyid: localStorage.getItem("companyid") || 1,
      pricelistid: priceListId
    };
    try {
      const response = await callApi(
        API_ENDPOINTS.SALES_PRICELIST_GET_GSM_BREAKDOWN,
        "POST",
        { "Content-Type": "application/json" },
        param
      );
      if (Array.isArray(response)) {
        setBreakdownData(response);
      } else {
        setBreakdownData([]);
        alert("No data found.");
      }
    } catch (err) {
      console.error("Breakdown fetch error:", err);
      alert("Error loading breakdown data.");
    }
  };

  const handleGsmChange = (index, field, value) => {
    const updated = [...gsmRanges];
    updated[index][field] = value;
    setGsmRanges(updated);
  };

  const handleRowClick = (row) => {
    setSelectedRow(row);
    const matchedQuality = qualityOptions.find(
      (opt) => opt.name === row.variety
    );
    if (matchedQuality) {
      setQuality(matchedQuality.code);
    }
    setGsmRanges([
      {
        id: row.pricelistitemid || Date.now(),
        gsmStart: row.gsmstart,
        gsmEnd: row.gsmend,
        reelPrice: row.reelprice,
        sheetPrice: row.sheetprice,
        pricelistitemid: row.pricelistitemid || 0,
        pricelistitemextid: row.pricelistitemextid || 0
      }
    ]);
    setQualityLocked(true);
    setIsUpdateMode(true);
    setEditingId(row.pricelistitemid || null);
  };

  const handleSave = async () => {
    if (!priceListId || !quality) {
      alert("Price List or Quality is missing.");
      return;
    }
const handleClear = () => {
  setGsmRanges([
    {
     
      gsmStart: "",
      gsmEnd: "",
      reelPrice: "",
      sheetPrice: ""
    }
  ]);

  // setQuality(null);
  // setQualityLocked(false);
  // setIsUpdateMode(false);
  // setEditingId(null);
  // setSelectedRow(null);
};

    // ✅ Validation 1: Required fields
    const invalidRow = gsmRanges.find(
      (row) =>
        row.gsmStart === "" ||
        row.gsmEnd === "" ||
        row.reelPrice === "" ||
        row.sheetPrice === ""
    );
    if (invalidRow) {
      alert("All GSM range fields are required.");
      return;
    }

    // ✅ Validation 2: GSM Start < GSM End
    for (let i = 0; i < gsmRanges.length; i++) {
      const row = gsmRanges[i];
      if (parseInt(row.gsmStart) >= parseInt(row.gsmEnd)) {
        alert(`Row ${i + 1}: GSM End must be greater than Start.`);
        return;
      }
    }

    // ✅ Validation 3: Duplicate GSM Start check
    const starts = gsmRanges.map((r) => r.gsmStart);
    const hasDuplicateStart = starts.some(
      (val, idx) => starts.indexOf(val) !== idx
    );
    if (hasDuplicateStart) {
      alert("Duplicate GSM Start value found. Please verify.");
      return;
    }

    // ✅ Validation 4: Overlap within AddGsm table
    for (let i = 0; i < gsmRanges.length; i++) {
      for (let j = i + 1; j < gsmRanges.length; j++) {
        const r1 = gsmRanges[i];
        const r2 = gsmRanges[j];
        if (r1.gsmStart <= r2.gsmEnd && r1.gsmEnd >= r2.gsmStart) {
          alert(
            `Row ${i + 1} overlaps with Row ${j + 1}. Please adjust GSM ranges.`
          );
          return;
        }
      }
    }

    // ✅ Validation 5: Overlap with BreakdownData for same Quality
    const qualityName = qualityOptions.find(q => q.code === quality)?.name;
    for (let i = 0; i < gsmRanges.length; i++) {
      const newRow = gsmRanges[i];
      const existingRows = breakdownData.filter(r => r.variety === qualityName);

      for (let j = 0; j < existingRows.length; j++) {
        const existing = existingRows[j];

        const newStart = parseInt(newRow.gsmStart);
        const newEnd = parseInt(newRow.gsmEnd);
        const oldStart = parseInt(existing.gsmstart);
        const oldEnd = parseInt(existing.gsmend);

        if (newStart <= oldEnd && newEnd >= oldStart) {
          alert(
            `Row ${i + 1}: GSM range (${newStart}-${newEnd}) overlaps with existing range (${oldStart}-${oldEnd}) for this Quality.`
          );
          return;
        }
      }
    }

    // ✅ If all validations passed → proceed with save
    const companyId = localStorage.getItem("companyid") || 1;
    const payload = gsmRanges.map((row) => ({
      p_companyid: companyId,
      p_pricelistid: priceListId,
      p_pricelistitemid: isUpdateMode ? row.pricelistitemid : 0,
      p_pricelistitemextid: isUpdateMode ? row.pricelistitemextid : 0,
      p_productvarietyid: quality,
      p_gsmstart: row.gsmStart,
      p_gsmend: row.gsmEnd,
      p_reelprice: row.reelPrice,
      p_sheetprice: row.sheetPrice,
      p_modifieduser: "admin"
    }));

    try {
      const result = await callApi(
        API_ENDPOINTS.SALES_SAVE_PRICELIST_GSM_BREAKDOWN,
        "POST",
        { "Content-Type": "application/json" },
        payload
      );
      if (Array.isArray(result) && result.length > 0) {
        alert(
          isUpdateMode
            ? "GSM Range updated successfully."
            : "GSM Range saved successfully."
        );
        setGsmRanges([]);
        setQuality(null);
        setQualityLocked(false);
        setIsUpdateMode(false);
        setEditingId(null);
        setSelectedRow(null);
        handleShowBreakdown();
      } else {
        alert("Failed to save GSM Range.");
      }
    } catch (err) {
      console.error("Save error:", err);
      alert("API error while saving GSM Range.");
    }
  };

  return (
    <Box>
      {/* <Header title="Add GSM Range" subtitle="" callback={handlecallback} /> */}
      {/* <Header title="Add GSM Range" subtitle="" callback={handlecallback} /> */}

<GsmRangeActionMenu
  isUpdateMode={isUpdateMode}
  onSave={handleSave}
  onClear={() => {
    setGsmRanges([]);
    setQuality(null);
    setQualityLocked(false);
    setSelectedRow(null);
    setIsUpdateMode(false);
  }}
  onExit={handlecallback}
/>

<Divider sx={{ mb: 2 }} />

      <Box px={2} py={1}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography fontSize={14}>Price List ID</Typography>
            <TextField value={String(priceListId)} fullWidth size="small" disabled />
          </Grid>
          <Grid item xs={6}>
            <Typography fontSize={14}>Price List Name</Typography>
            <TextField value={priceListName} fullWidth size="small" disabled />
          </Grid>
          <Grid item xs={6}>
            <Typography fontSize={14}>Quality</Typography>
            <Autocomplete
              options={qualityOptions}
              getOptionLabel={(opt) => opt.name || ""}
              value={qualityOptions.find((opt) => opt.code === quality) || null}
              onChange={(e, val) => setQuality(val ? val.code : null)}
              renderInput={(params) => (
                <TextField {...params} fullWidth size="small" />
              )}
              disabled={qualityLocked}
            />
          </Grid>
        </Grid>

        <Box mt={3}>
          <Typography fontSize={14}>GSM Ranges</Typography>
          <Box display="flex" alignItems="center" mb={2}>
            <Button
              onClick={handleAddGsmRow}
              variant="outlined"
              color="secondary"
              size="small"
              sx={{ textTransform: "none", mr: 2 }}
            >
              + Add New GSM Range Row
            </Button>
            <FormControlLabel
              control={
                <Checkbox
                  checked={retainGsm}
                  onChange={() => setRetainGsm(!retainGsm)}
                  size="small"
                />
              }
              label="Retain GSM Range"
            />
          </Box>

          {gsmRanges.map((row, index) => (
            <Grid
              container
              spacing={1}
              key={row.id}
              mb={1}
              alignItems="center"
            >
              <Grid item xs={2}>
                <TextField
                  label="GSM Start"
                  type="number"
                  size="small"
                  value={row.gsmStart}
                  onChange={(e) =>
                    handleGsmChange(index, "gsmStart", parseInt(e.target.value))
                  }
                  fullWidth
                />
              </Grid>
              <Grid item xs={2}>
                <TextField
                  label="GSM End"
                  type="number"
                  size="small"
                  value={row.gsmEnd}
                  onChange={(e) =>
                    handleGsmChange(index, "gsmEnd", parseInt(e.target.value))
                  }
                  fullWidth
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  label="Reel Price"
                  type="number"
                  size="small"
                  value={row.reelPrice}
                  onChange={(e) =>
                    handleGsmChange(index, "reelPrice", e.target.value)
                  }
                  fullWidth
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  label="Sheet Price"
                  type="number"
                  size="small"
                  value={row.sheetPrice}
                  onChange={(e) =>
                    handleGsmChange(index, "sheetPrice", e.target.value)
                  }
                  fullWidth
                />
              </Grid>
              <Grid item xs={2}>
                <Button
                  color="secondary"
                  variant="outlined"
                  size="small"
                  onClick={() => {
                    const updated = gsmRanges.filter((_, i) => i !== index);
                    setGsmRanges(updated);
                  }}
                >
                  Clear
                </Button>
              </Grid>
            </Grid>
          ))}
        </Box>

        {/* <Box
          sx={{ mt: 2, display: "flex", justifyContent: "flex-end", gap: 2 }}
        >
          <Button
            onClick={handleSave}
            variant="contained"
            size="small"
            color="secondary"
            startIcon={<SaveAltIcon />}
            sx={{ textTransform: "none" }}
          >
            {isUpdateMode ? "Update" : "Save"}
          </Button>
          <Button
            size="small"
            variant="contained"
            sx={{ backgroundColor: "maroon", textTransform: "none" }}
            startIcon={<Cancel />}
            onClick={handlecallback}
          >
            Cancel
          </Button>
        </Box> */}

        <Box mt={4}>
          <Button
            onClick={handleShowBreakdown}
            variant="contained"
            size="small"
            sx={{ backgroundColor: theme.palette.secondary.main }}
          >
            Show Breakdown Details
          </Button>

          {breakdownData.length > 0 && (
            <Paper elevation={3} sx={{ mt: 2, p: 2 }}>
              <Typography variant="h6" gutterBottom>
                Breakdown Data
              </Typography>
              <TableContainer sx={{ maxHeight: 300 }}>
                <Table stickyHeader size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Variety</TableCell>
                      <TableCell>GSM Start</TableCell>
                      <TableCell>GSM End</TableCell>
                      <TableCell>Reel Price</TableCell>
                      <TableCell>Sheet Price</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {breakdownData.map((row, index) => (
                      <TableRow
                        key={index}
                        hover
                        onClick={() => handleRowClick(row)}
                        selected={selectedRow === row}
                        sx={{
                          cursor: "pointer",
                          bgcolor:
                            selectedRow === row
                              ? colors.primary[400]
                              : colors.primary[600]
                        }}
                      >
                        <TableCell>{row.variety}</TableCell>
                        <TableCell>{row.gsmstart}</TableCell>
                        <TableCell>{row.gsmend}</TableCell>
                        <TableCell>{row.reelprice}</TableCell>
                        <TableCell>{row.sheetprice}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default AddGsmRange;
